module.exports = __webpack_public_path__ + "static/media/dadrp.72e11ce7.svg";